/* ------------------------------------------- */
/*   Queries for the SAML auth
/* ------------------------------------------- */

import { AppConfig } from 'AppSrc/core/config/app-config';
import { getRESTQuery } from 'AppSrc/core/queries/axios-queries';

// Returns a 200 if the requester JWT token is valid. (v1AuthcheckGet)
const getV1Authcheck = () => {

  // const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.auth.V1Authcheck}`;
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.auth.V1Authcheck}`;

  return getRESTQuery(endpoint, {})
    .then((response) => response);
};

// Gets a SAML AuthnRequest URL for redirecting to the SSO page.
// relayState: The URL the user was trying to access (they will be forwarded on to this url after they have authed with SAML).
const getSAMLAuthenticate = (relayState) => {

  // const endpoint = `${AppConfig.authenticationBaseUrl}${AppConfig.endpoints.auth.SAMLAuthenticate}`;
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.auth.SAMLAuthenticate}`;
  const query = {
    relay_state: relayState,
  };

  return getRESTQuery(endpoint, query)
    .then((response) => response.data.auth_url);
};


export {
  getV1Authcheck,
  getSAMLAuthenticate,
};
